module.exports = __webpack_public_path__ + "img/old1.e95d4bbf.jpg";